(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbc-shop-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.tbcQuickShopReady) {
  window.tbcQuickShopReady = true;
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-tbc-quick-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) { dialog.dataset.returnFocus = opener.id || ''; dialog.showModal(); dialog.querySelector('[data-tbc-quick-close]').focus(); }
      return;
    }
    var dialog = event.target.closest('[data-tbc-quick-dialog]');
    if (!dialog) return;
    if (event.target === dialog || event.target.closest('[data-tbc-quick-close]')) { dialog.close(); return; }
    var row = event.target.closest('[data-tbc-quick-variant]');
    if (row && (event.target.closest('[data-tbc-quick-plus]') || event.target.closest('[data-tbc-quick-minus]'))) {
      var output = row.querySelector('[data-tbc-quick-quantity]');
      output.textContent = Math.max(0, Number(output.textContent) + (event.target.closest('[data-tbc-quick-plus]') ? 1 : -1));
      dialog.querySelector('[data-tbc-quick-add]').disabled = !Array.from(dialog.querySelectorAll('[data-tbc-quick-quantity]')).some(function (el) { return Number(el.textContent) > 0; });
    }
    if (!event.target.closest('[data-tbc-quick-add]')) return;
    var button = dialog.querySelector('[data-tbc-quick-add]');
    var items = Array.from(dialog.querySelectorAll('[data-tbc-quick-variant]')).map(function (el) { return { id: Number(el.dataset.variantId), quantity: Number(el.querySelector('[data-tbc-quick-quantity]')?.textContent || 0) }; }).filter(function (item) { return item.quantity > 0; });
    if (!items.length) return;
    button.disabled = true;
    var status = dialog.querySelector('[data-tbc-quick-status]');
    status.textContent = 'Adding to cart…';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (response) { return response.json().then(function (body) { if (!response.ok) throw new Error(body.description || 'Could not add items.'); return body; }); })
      .then(function () { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; })
      .catch(function (error) { status.textContent = error.message; button.disabled = false; });
  });
}
  } catch(e) { console.error(e); }
})();

})();
